import * as React from 'react';
import { Tab, withStyles, createStyles } from '@material-ui/core';
import { theme } from '../../../theme';

export interface IEntityTabProps {
	label: string;
	icon: JSX.Element;
	visible?: boolean;
}

const EntityTab = withStyles(() =>
	createStyles({
		root: {
			textTransform: 'none',
			opacity: 1,
			minWidth: 'fit-content',
			minHeight: '50px',
			backgroundColor: '#E2E2E2',
			borderLeft: '1px solid #424242',
			borderRight: '1px solid #424242',
			fontSize: '1.25rem',
			fontWeight: 'normal',
			'&:first-child': {
				borderLeft: 'none',
			},
			'&:last-child': {
				borderRight: 'none',
			},
			'&:hover': {
				fontWeight: 'bold',
			},
			'&$selected': {
				color: 'black',
				backgroundColor: '#fff',
			},
			[theme.breakpoints.down(1381)]: {
				minWidth: '33%',
			},
			[theme.breakpoints.down('xs')]: {
				minWidth: '100%',
				fontSize: '1.10rem',
			},
		},
		selected: {},
		wrapper: {
			flexDirection: 'row',
			root: {
				marginBottom: '0',
			},
		},
	})
)((props: IEntityTabProps) => <Tab disableRipple {...props} />);

EntityTab.defaultProps = {
	visible: true,
};

export default EntityTab;
